import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function Header() {
  const { isAdmin, logout } = useAuth();

  return (
    <header className="site-header">
      <div className="container">
        <Link to="/" className="site-logo">Baby<span>Finds</span></Link>
        <nav className="header-nav">
          <NavLink to="/" end className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>
            Storefronts
          </NavLink>
          {isAdmin && (
            <>
              <NavLink to="/admin" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>
                Admin
              </NavLink>
              <button className="btn btn-ghost btn-sm" style={{color:"rgba(250,247,242,.7)"}} onClick={logout}>
                Log out
              </button>
            </>
          )}
          {!isAdmin && (
            <NavLink to="/admin/login" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>
              Admin
            </NavLink>
          )}
        </nav>
      </div>
    </header>
  );
}
